export const AppInterfaceResultCode = {
    ok:                                 'ok',
    error:                              'error',
};

export const AppInterfaceErrorTypes = {
    std:                                'std',
    changeTarget:                       'changeTarget',
};

export const AppInterfaceErrorReasons = {
    blocked:                            'blocked',
    notReady:                           'notReady',
    invalidParameter:                   'invalidParameter',
    uiBlock:                            'uiBlock',
    couldNotFindItem:                   'couldNotFindItem',
    couldNotDownloadFile:               'couldNotDownloadFile',
    fileCorrupt:                        'fileCorrupt',
    couldNotParseXML:                   'couldNotParseXML',
    unexpected:                         'unexpected'
};

export class AppInterfaceError    {

    constructor(type = AppInterfaceErrorTypes.std, reason = AppInterfaceErrorReasons.unexpected, path = undefined){
        this.type = type;
        if(type === AppInterfaceErrorTypes.std) this.reason = reason;
        if(type === AppInterfaceErrorTypes.changeTarget) this.result = reason;
        this.path = path;
    }

    print() {
        let type = this.type || 'unkown';

        let str = 'Interface error - ' + type;
        if(this.type == AppInterfaceErrorTypes.std)  {
            let reason = this.reason || 'unkown';
            str += '\n\treason: ' + reason;
            if(this.path)  str += '\n\tpath: ' + this.path;
        } else if(this.type == AppInterfaceErrorTypes.changeTarget)  {
            str += this.result.toString('\t');
        }

        console.log(str);
    }
}

export class AppInterfaceResult   {

    constructor(code = AppInterfaceResultCode.ok, error = undefined, result = undefined){
        this.set(code, error);
        this.result = result;
    }

    set(code = AppInterfaceResultCode.ok, error = undefined)   {
        this.code = code;
        this.error = code === AppInterfaceResultCode.ok || error ? error : new AppInterfaceError();
    }

    setWithError(error = undefined) {
        this.code = error ? AppInterfaceResultCode.error : AppInterfaceResultCode.ok;
        this.error = error;
    }

    isOk()  {
        return this.code === AppInterfaceResultCode.ok;
    }

    isError()   {
        return this.code === AppInterfaceResultCode.error;
    }
}

AppInterfaceResult.ok = function(result)   {
    return new AppInterfaceResult(AppInterfaceResultCode.ok, undefined, result);
};

AppInterfaceResult.error = function(type = AppInterfaceErrorTypes.std, reason = AppInterfaceErrorReasons.unexpected, path = undefined)   {
    return new AppInterfaceResult(AppInterfaceResultCode.error, new AppInterfaceError(type, reason, path));
};

export const AppInterfaceEvents = {
    blockedChange:                      'blockedChange'
};